// extracted by mini-css-extract-plugin
export default {"navigationList":"navigation_navigationList__tSu+N","navigationItem":"navigation_navigationItem__cCq8e"};